<template>
  <BadgeItem
    :name="name"
    :image-src="image"
    image-alt="level"
    :is-locked="isLocked"
    @click="$emit('show:levelDetails')"
  />
</template>

<script setup>
import { computed } from 'vue';
import BadgeItem from '@/views/profileOverview/components/item/BadgeItem.vue';
import useAuthStore from '@/store/modules/auth.js';
import { getLevelBadgeImage, getLevelNameTranslationKey } from '@/helpers/reward.js';

defineEmits(['show:levelDetails']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const authStore = useAuthStore();

const level = computed(() => props.item.__level || 0);
const name = computed(() => getLevelNameTranslationKey(level.value));
const image = computed(() => getLevelBadgeImage(level.value));
const isCurrent = computed(() => authStore.user.level === level.value);
const isCompleted = computed(() => props.item.threshold <= authStore.user.gamesPlayed);
const isLocked = computed(() => !isCompleted.value && !isCurrent.value);
</script>
